import MapView = require("esri/views/MapView");
import ToolBar from "./../Toolbar";

// base class for tool buttons

export interface ToolButtonInterface {
  view: MapView;
  toolbar: ToolBar;
  iconDiv: HTMLElement;

  activateTool(event: any): void;
  deactivateTool(): void;
}

export default class ToolButton implements ToolButtonInterface {
  view: MapView;
  toolbar: ToolBar;
  iconDiv: HTMLElement;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    this.view = viewIn;
    this.toolbar = toolbarIn;
  }

  activateTool(event: any): void {
    console.error("ERRROR activateTool NOT IMPLEMENTED!!");
  }

  deactivateTool(): void {
    console.error("ERRROR deactivateTool NOT IMPLEMENTED!!");
  }
}
